import * as css from './StatCard.css';

export interface StatCardProps {
    value: string;
    label: string;
    additionalInfo?: string;
}

function StatCard({value, label, additionalInfo}: StatCardProps) {
    return (
        <css.statCard>
            <css.value>{value}</css.value>
            <css.label>{label}</css.label>
            {additionalInfo && (
                <css.additionalInfo>{additionalInfo}</css.additionalInfo>
            )}
        </css.statCard>
    );
}

export default StatCard;

